import React from 'react';

interface LoadSpinnerProps {
  position?: 'static' | 'absolute';
  verticalMargin?: number;
}

function LoadSpinner({ position = 'static', verticalMargin = 0 }: LoadSpinnerProps) {
  return (
    <>
      <style jsx>{`
        .lds-ring {
        position: relative;
        display: grid;
        place-items: center;
        height: 95vh;
        overflow: hidden;
    }
    .lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 64px;
        height: 64px;
        margin: 8px;
        border: 8px solid #e10a0a;
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: #e10a0a transparent transparent transparent;
    }
    .lds-ring div:nth-child(1) {
        animation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
        animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
        animation-delay: -0.15s;
    }
    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
      `}</style>
        <div className="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </>
  );
}

export { LoadSpinner };
